import { lazyWithPreload } from '@shared/utils/lazyWithPreload';

/**
 * lottie-react, code-split so the ~80KB (gzipped) lottie-web player is not part
 * of the app's initial download. For components rendered before any page code
 * loads (route loader, offline screen); App preloads it once the browser is
 * idle, after which it renders without suspending.
 */
export const LazyLottie = lazyWithPreload(() => import('lottie-react'));

export const preloadLottie = () => LazyLottie.preload();
